import { motion } from "framer-motion";
import { Apple, Play } from "lucide-react";
import { ASSETS } from "@/lib/content";
import { PhoneFrame } from "@/components/PhoneFrame";

const StoreButton = ({ icon: Icon, top, bottom, testId }) => (
  <a
    href="#download"
    data-testid={testId}
    className="group flex items-center gap-3 rounded-2xl bg-gray-900 px-6 py-3.5 text-white shadow-lg shadow-gray-900/20 transition-all hover:-translate-y-0.5 hover:bg-black"
  >
    <Icon size={26} className="shrink-0" />
    <span className="text-left leading-tight">
      <span className="block text-[11px] font-medium opacity-70">{top}</span>
      <span className="block font-heading text-base font-bold">{bottom}</span>
    </span>
  </a>
);

export const Hero = () => {
  return (
    <section id="top" className="relative overflow-hidden pt-32 pb-20 sm:pt-40 sm:pb-28">
      <div className="bg-grain pointer-events-none absolute inset-0 opacity-70" />
      <div
        className="pointer-events-none absolute -right-32 -top-24 h-[34rem] w-[34rem] rounded-full opacity-40 blur-3xl"
        style={{ background: "radial-gradient(circle, #22c55e55, transparent 70%)" }}
      />

      <div className="relative mx-auto grid max-w-7xl grid-cols-1 items-center gap-12 px-6 lg:grid-cols-2 lg:gap-8 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: "easeOut" }}
        >
          <span
            data-testid="hero-badge"
            className="inline-flex items-center gap-2 rounded-full border border-emerald-200 bg-emerald-50 px-4 py-1.5 text-sm font-semibold text-emerald-700"
          >
            <span className="h-2 w-2 rounded-full bg-emerald-500" />
            Meet Bast, keeper of your Purrse
          </span>

          <h1 className="mt-6 font-heading text-5xl font-extrabold leading-[1.05] tracking-tight text-gray-900 sm:text-6xl">
            Your money,
            <br />
            but make it <span className="text-emerald-500">purr.</span>
          </h1>

          <p className="mt-6 max-w-xl text-lg leading-relaxed text-gray-600">
            Budgeting apps treat you like a problem to fix. Purrse treats you like someone who
            deserves to enjoy their money. Pick your three, set a fun budget, and let Bast handle
            the side eye.
          </p>

          <div id="download" className="mt-9 flex flex-wrap gap-4">
            <StoreButton
              icon={Apple}
              top="Coming soon on the"
              bottom="App Store"
              testId="hero-appstore-btn"
            />
            <StoreButton
              icon={Play}
              top="Coming soon on"
              bottom="Google Play"
              testId="hero-playstore-btn"
            />
          </div>

          <p className="mt-5 text-sm italic text-gray-500">
            "You can afford almost anything. You just can't afford everything."
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.92 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, delay: 0.15, ease: "easeOut" }}
          className="flex justify-center"
        >
          <PhoneFrame src={ASSETS.shots.welcome} alt="Purrse welcome screen" float />
        </motion.div>
      </div>
    </section>
  );
};
